/**
 * Set a cookie with the given name, value and expiration days
 */
export function setBrowserCookie(
  name: string,
  value: string,
  days: number = 365,
) {
  const maxAge = days * 24 * 60 * 60
  document.cookie = `${name}=${encodeURIComponent(value)}; max-age=${maxAge}; path=/; SameSite=Lax`
}

/**
 * Get a cookie value by name
 * @returns The cookie value or null if not found
 */
export function getBrowserCookie(name: string): string | null {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) {
    const cookieValue = parts.pop()?.split(';').shift()
    return cookieValue ? decodeURIComponent(cookieValue) : null
  }
  return null
}

/**
 * Remove a cookie by setting its expiration to a past date
 */
export function removeBrowserCookie(name: string) {
  document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=Lax`
}

export type CookiePreferences = {
  essential: boolean
  marketing: boolean
  externalMedia: boolean
  statistic: boolean
}
